import { render } from "./TeamDropdown.vue?vue&type=template&id=3c32a6e3"
import script from "./TeamDropdown.vue?vue&type=script&lang=js"
export * from "./TeamDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__